var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":_vm.sourceData.team_name,"size":"small","bordered":false}},[_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":`task-detail-${_vm.sourceData.team_id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }